import { $authHost } from "../../http";
import { 
    TRANSPORTATION_CONDITION_GET_REQUEST, TRANSPORTATION_CONDITION_GET_SUCCESS, TRANSPORTATION_CONDITION_GET_ERROR, 
    TRANSPORTATION_CONDITION_GET_BY_KEY_REQUEST, TRANSPORTATION_CONDITION_GET_BY_KEY_SUCCESS, TRANSPORTATION_CONDITION_GET_BY_KEY_ERROR, 
    TRANSPORTATION_CONDITION_ADD_REQUEST, TRANSPORTATION_CONDITION_ADD_SUCCESS, TRANSPORTATION_CONDITION_ADD_ERROR, 
    TRANSPORTATION_CONDITION_EDIT_REQUEST, TRANSPORTATION_CONDITION_EDIT_SUCCESS, TRANSPORTATION_CONDITION_EDIT_ERROR, 
    TRANSPORTATION_CONDITION_DELETE_REQUEST, TRANSPORTATION_CONDITION_DELETE_SUCCESS, TRANSPORTATION_CONDITION_DELETE_ERROR
} from "../constants/transportationConditionConstants";

export const getTransportationConditions = (args) => async (dispatch) => {
    try {
        dispatch({
            type: TRANSPORTATION_CONDITION_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/transportationCondition/query",
            args || {},
            config,
        );
        dispatch({
            type: TRANSPORTATION_CONDITION_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: TRANSPORTATION_CONDITION_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getTransportationConditionByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: TRANSPORTATION_CONDITION_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/transportationCondition/${id}`,
        );
        dispatch({
            type: TRANSPORTATION_CONDITION_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: TRANSPORTATION_CONDITION_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addTransportationCondition = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: TRANSPORTATION_CONDITION_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/transportationCondition",
            { name, code, description },
            config,
        );
        dispatch(getTransportationConditions(queryArgs || {}));
        dispatch({
            type: TRANSPORTATION_CONDITION_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: TRANSPORTATION_CONDITION_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editTransportationCondition = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: TRANSPORTATION_CONDITION_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/transportationCondition",
            { id, name, code, description },
            config,
        );
        dispatch(getTransportationConditions(queryArgs || {}));
        dispatch({
            type: TRANSPORTATION_CONDITION_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: TRANSPORTATION_CONDITION_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteTransportationCondition = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: TRANSPORTATION_CONDITION_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/transportationCondition",
            { data: { id } },
            config,
        );
        dispatch(getTransportationConditions(queryArgs || {}));
        dispatch({
            type: TRANSPORTATION_CONDITION_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: TRANSPORTATION_CONDITION_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

